// src/pages/pengamatan/buah-alami/BuahAlamiTableHeader.jsx
import React from 'react';
import { 
    TableHead, 
    TableRow, 
    TableCell, 
    Checkbox, 
    Tooltip,
    Box
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import './css/BuahAlamiTableHeader.css';

const BuahAlamiTableHeader = ({ 
    currentTab,
    selectedItems,
    orders,
    handleSelectAll,
    areAllItemsOnCurrentPageSelected,
    userJabatan,
    userRoleNames
}) => {
    // Fungsi untuk menentukan status checkbox header
    const getHeaderCheckboxState = () => {
        if (orders.length === 0) return { checked: false, indeterminate: false };
        
        const allSelected = areAllItemsOnCurrentPageSelected();
        const someSelected = selectedItems.length > 0 && !allSelected;
        
        return {
            checked: allSelected,
            indeterminate: someSelected
        };
    };

    // FUNGSI BARU: Cek akses untuk ID Pengamatan
    const canViewPengamatanId = () => {
        return userJabatan === "Section Head" && userRoleNames.includes("Developer");
    };

    // FUNGSI BARU: Cek akses untuk edit (tombol EditIcon)
    const canAccessEdit = () => {
        const isValidJabatan = userJabatan === "Admin" || userJabatan === "Section Head";
        const isValidRole = userRoleNames.includes("Buah Alami") || userRoleNames.includes("Developer");
        
        return isValidJabatan && isValidRole;
    };

    // FUNGSI BARU: Cek apakah checkbox harus ditampilkan di header
    const shouldShowCheckbox = () => {
        const isCorrectTab = currentTab === 'Approved' || currentTab === 'Processed' || currentTab === 'Closing';
        
        // LOGIKA BARU: Di tab Processed dan Closing, SEMUA USER bisa melihat checkbox
        if (currentTab === 'Processed' || currentTab === 'Closing') {
            return true;
        }
        
        // Untuk tab Approved, hanya user dengan akses tertentu
        const hasAccess = canAccessEdit();
        return hasAccess && isCorrectTab;
    };

    const { checked, indeterminate } = getHeaderCheckboxState();

    // KONFIGURASI HEADER - KOLOM BISA HILANG BERDASARKAN AKSES
    const headerConfig = [
        // Checkbox header - LOGIKA BARU: Di tab Processed dan Closing semua user bisa lihat
        ...(shouldShowCheckbox() ? [{
            id: 'checkbox', 
            label: (
                <Checkbox
                    indeterminate={indeterminate}
                    checked={checked}
                    onChange={handleSelectAll}
                    color="primary"
                />
            ), 
            rowSpan: 2, 
            colSpan: 1,
            className: 'buah-alami-table-header checkbox'
        }] : []),
        // KOLOM ID PENGAMATAN HANYA DITAMPILKAN JIKA USER MEMILIKI AKSES
        ...(canViewPengamatanId() ? [{
            id: 'id_pengamatan', 
            label: (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    ID Pengamatan
                    <Tooltip title="Hanya dapat diakses oleh Section Head dengan role Developer">
                        <InfoIcon fontSize="small" sx={{ color: 'text.secondary', fontSize: 16 }} />
                    </Tooltip>
                </Box>
            ), 
            rowSpan: 2, 
            colSpan: 1,
            className: 'buah-alami-table-header'
        }] : []),
        { 
            id: 'tanggal_pengamatan', 
            label: 'Tanggal Pengamatan', 
            rowSpan: 2, 
            colSpan: 1,
            className: 'buah-alami-table-header'
        },
        { 
            id: 'lokasi', 
            label: 'Lokasi', 
            rowSpan: 2, 
            colSpan: 1,
            className: 'buah-alami-table-header'
        },
        { 
            id: 'fmp', 
            label: 'F-/+', 
            rowSpan: 2, 
            colSpan: 1,
            className: 'buah-alami-table-header'
        },
        { 
            id: 'mandor', 
            label: 'Mandor', 
            rowSpan: 2, 
            colSpan: 1,
            className: 'buah-alami-table-header'
        },
        { 
            id: 'pengamat', 
            label: 'Pengamat', 
            rowSpan: 2, 
            colSpan: 1,
            className: 'buah-alami-table-header'
        },
        { 
            id: 'jumlah_plot', 
            label: 'Jumlah Plot', 
            rowSpan: 2, 
            colSpan: 1,
            className: 'buah-alami-table-header'
        },
        { 
            id: 'aksi', 
            label: 'Aksi', 
            rowSpan: 2, 
            colSpan: 1,
            className: 'buah-alami-table-header aksi'
        }
    ];

    return (
        <TableHead>
            <TableRow>
                {headerConfig.map((header) => (
                    <TableCell
                        key={header.id}
                        rowSpan={header.rowSpan}
                        colSpan={header.colSpan}
                        className={header.className}
                        padding="normal"
                    >
                        {header.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default BuahAlamiTableHeader;